var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Actions from '../actions/lang.actions';
import * as locals from 'src/translation/locals/lang.json';
import { ALL_LANG_NAMES } from 'src/translation/index';
var initialState = {
    'en-us': __assign(__assign({}, locals), ALL_LANG_NAMES),
};
var lang = function (state, action) {
    var _a;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case Actions.SET_LANG: {
            return __assign(__assign({}, state), (_a = {}, _a[action.payload.lang] = __assign(__assign({}, ALL_LANG_NAMES), action.payload.data), _a));
        }
        default: {
            return state;
        }
    }
};
export default lang;



//////////////////
// WEBPACK FOOTER
// ./src/auth/store/reducers/language.reducer.ts
// module id = 1481
// module chunks = 81